import useScrollReveal from '@/hooks/useScrollReveal';
import SectionHeading from '@/components/feature/SectionHeading';

export default function ContactSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="kontakt" className="relative py-16 md:py-24 px-4 md:px-6 bg-background-50 scroll-mt-16 md:scroll-mt-20" ref={ref}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <SectionHeading
          eyebrow="Kontakt"
          title="Stopimo v stik"
          description="Imate vprašanje? Pokličite nas, pišite na Facebooku ali nas preprosto obiščite — vedno smo vam na voljo."
        />

        {/* Contact Cards */}
        <div
          className={`grid grid-cols-1 md:grid-cols-3 gap-5 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Address */}
          <div className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-4">
              <i className="ri-map-pin-line text-primary-600 text-xl"></i>
            </div>
            <p className="text-sm font-semibold text-foreground-100 mb-2">Naslov</p>
            <p className="text-sm text-foreground-300">Zamušani 2, 2272 Gorišnica</p>
            <p className="text-xs text-foreground-500 mt-1">Tik ob glavni cesti</p>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Zamu%C5%A1ani+2,+2272+Gori%C5%A1nica"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-navigation-line"></i>
              Navodila za pot
            </a>
          </div>

          {/* Phone */}
          <div className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
              <i className="ri-phone-line text-accent-600 text-xl"></i>
            </div>
            <p className="text-sm font-semibold text-foreground-100 mb-2">Telefon</p>
            <div className="flex flex-col gap-1">
              <a href="tel:051240383" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">051 240 383</a>
            </div>
          </div>

          {/* Facebook */}
          <div className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
              <i className="ri-facebook-circle-fill text-secondary-600 text-xl"></i>
            </div>
            <p className="text-sm font-semibold text-foreground-100 mb-2">Facebook</p>
            <p className="text-sm text-foreground-300">Novosti in dogodki</p>
            <a
              href="https://www.facebook.com/GumaBarZamusani"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-secondary-500 hover:text-secondary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line"></i>
              Guma Caffe Lounge Bar
            </a>
          </div>
        </div>

        {/* Map */}
        <div
          className={`mt-8 md:mt-10 rounded-lg overflow-hidden border border-background-200/60 transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <iframe
            title="Lokacija GUMA BAR na zemljevidu"
            src="https://maps.google.com/maps?q=Zamu%C5%A1ani%202%2C%202272%20Gori%C5%A1nica&t=&z=15&ie=UTF8&iwloc=&output=embed"
            className="w-full h-[280px] md:h-[420px] block border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}